import { GridPostParams } from "common/models/utility-models/list-utility.model";

export class DocumentReportsGridPostParams extends GridPostParams {
    reportTypeFlag: number = 9;
    search_keyword: '';
    region_search: string = '';
    batch_search: any = '';
    branch_search: any = '';
    state_search: any = '';
    gender_search: string = ''
    isAnnual: any = 1;
    periodValue: any = 1;
    documentTypeId: any = 1;
    uploaded_search: any = '';
}
